import { render, staticRenderFns } from "./products.vue?vue&type=template&id=46613c32&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/page_style/products.scss?vue&type=style&index=0&id=46613c32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46613c32",
  null
  
)

export default component.exports